import { Col, Row, Card, Divider, Typography, Space, Button } from "antd";
import { useEffect, useState } from "react";
import { DonutProgress } from "../../../../portal/view/DonutProgress";
import { BidirectionalBar } from '@ant-design/plots';
import { useConfirmTuitionFee } from "../../ConfirmTuitionFee/Controller/useConfirmTuitionFeeController";
import { useProtalMainPage } from "../controller/useProtalMainPage";
import LabelBarChart from "../../../../charts/bar_chart/view/LabelBarChart";
import SmallTable from "../../../../charts/small_table/view/SmallTable";
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import dayjs from 'dayjs'

const ProtalMainPage = (props) => {
    const language = props.language
    const navigate = useNavigate();

    const {
        perDayPayment,
        billPaymentStatistic,
        perClassPayment,
        perStudentPayment,
        getBillPaymentStatistic,
        getPerDayPayment,
        getPerClassPayment,
        getPerStudentPayment
    } = useProtalMainPage({
        onFinish: () => { },
        onBefore: () => { },
    })

    const {
        ConfirmTuitionFeeData,
        getConfirmTuitionFeeData,
    } = useConfirmTuitionFee(
        {
            onFinish: () => { },
            onBefore: () => { },
        }
    )

    useEffect(() => {
        let today = dayjs().format('YYYY-MM-DD')
        let dayStart = dayjs().subtract(3, 'day').format('YYYY-MM-DD')
        let dayEnd = dayjs().add(3, 'day').format('YYYY-MM-DD')
        getConfirmTuitionFeeData({
            cur_page: 1,
            size: 3,
            payment_limit_time_filter :1,
            payment_limit_time_start:today,
            payment_limit_time_end:today
        })
        getBillPaymentStatistic({})
        getPerDayPayment({
            date_start: dayStart,
            date_end: dayEnd
        })
        getPerClassPayment({})
        getPerStudentPayment({})
    }, [])
    return (
        <Row gutter={[24, 24]}  >

            <Col span={24}>
                <Row gutter={[16, 16]}  >
                    <Col
                        lg={10}
                        md={24}
                        sm={24}
                        xs={24}
                    >
                        <Card>
                            <Row span={[32, 32]}>
                                <Col span={24}>
                                    <Row>
                                        <Col span={24}>
                                            <Space  >
                                                <Typography.Title level={2}
                                                    style={{
                                                        padding: "0px",
                                                        margin: "0px"
                                                    }} >
                                                    學費管理
                                                </Typography.Title>
                                                {/* <Button
                                                    style={{
                                                        backgroundColor: "#748BC0",
                                                        color: "#fff"
                                                    }}
                                                    icon={<PlusCircleFilled
                                                        style={{ color: '#C6CDFB' }}
                                                    />}  >
                                                    發起會議
                                                </Button> */}
                                            </Space>
                                        </Col>
                                    </Row>
                                </Col>
                                <Divider />
                                <Col span={24}>
                                    <Row>
                                        <Col span={24}>
                                            <Typography.Title level={4}
                                            >
                                                繳費單統計
                                            </Typography.Title>
                                        </Col>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Text
                                                        style={{
                                                            color: "#EA898D"
                                                        }}
                                                    >
                                                        近7日
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        onClick={() => {
                                                            navigate(`/cramSchool/admin/ConfirmTuitionFee`)
                                                        }}
                                                        type="link">
                                                        查看更多
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <DonutProgress
                                                DonutDataKey={"value"}
                                                DonutData={billPaymentStatistic}
                                                colorTheams="demo1"
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Divider />
                                <Col span={24}>
                                    <Row gutter={[8, 16]}>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                < Col >
                                                    <Typography.Title level={4}
                                                    >
                                                        每日繳費人數
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        onClick={() => {
                                                            navigate(`/cramSchool/admin/ConfirmTuitionFee`)
                                                        }}
                                                        type="link">
                                                        查看更多
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24} >
                                            <div style={{
                                                height: '200px'
                                            }}
                                            >
                                                <LabelBarChart
                                                    XdataKey="date"
                                                    barDatas={[
                                                        {
                                                            dataKey: "繳費人數",
                                                            fill: "#8884d8"
                                                        },
                                                        // {
                                                        //     dataKey: "uv",
                                                        //     fill: "#82ca9d"
                                                        // },
                                                    ]}
                                                    barChartDatas={perDayPayment}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Divider />
                                <Col span={24}>
                                    <Row gutter={[8, 16]}>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                < Col >
                                                    <Typography.Title level={4}
                                                    >
                                                        今日繳費單資訊
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        onClick={() => {
                                                            navigate(`/cramSchool/admin/ConfirmTuitionFee`)
                                                        }}
                                                        type="link">
                                                        查看更多
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24} >
                                            <div style={{
                                                height: '200px'
                                            }}
                                            >
                                                <SmallTable
                                                    columns={[
                                                        {
                                                            title: '班級',
                                                            dataIndex: 'name_serial',
                                                            key: 'name',
                                                        },
                                                        {
                                                            title: '期數',
                                                            dataIndex: 'year',
                                                            key: 'year',
                                                            render: (text, record, index) => {
                                                                return (
                                                                    <>
                                                                        {record?.year}-{record?.year_serial}
                                                                    </>
                                                                )
                                                            }
                                                        },
                                                        {
                                                            title: '人數',
                                                            dataIndex: 'total_student',
                                                            key: 'total_student',
                                                            render: (text, record, index) => {
                                                                return (
                                                                    <>
                                                                        {record?.total_payment_student}/{record?.total_student}
                                                                    </>
                                                                )
                                                            }
                                                        },
                                                        {
                                                            title: '',
                                                            key: 'option',
                                                            render: (text, record, index) => {
                                                                return (<Button
                                                                    onClick={() => {
                                                                        navigate(`/cramSchool/admin/ConfirmTuitionFeeStudentDetail/${record?.bill_payment_id}`)
                                                                    }}
                                                                    type="text"
                                                                    style={{
                                                                        backgroundColor: "#ffc400"
                                                                    }}
                                                                >
                                                                    查看
                                                                </Button>)
                                                            }
                                                        }
                                                    ]}
                                                    dataSource={ConfirmTuitionFeeData}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col
                        lg={14}
                        md={24}
                        sm={24}
                        xs={24}
                    >
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Card
                                    size="small"
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Title level={4}
                                                    >
                                                        學生歷史繳費狀態
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        onClick={() => {
                                                            navigate(`/cramSchool/admin/ConfirmTuitionFee`)
                                                        }}
                                                        type="link">
                                                        查看更多
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col
                                            span={24}
                                        >
                                            <div style={{
                                                height: '400px'
                                            }}
                                            >
                                                <HistoryStatus
                                                    data={perStudentPayment}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col span={24}>
                                <Card
                                    size="small"
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Row justify={"space-between"}>
                                                <Col>
                                                    <Typography.Title level={4}
                                                    >
                                                        各班繳費狀態
                                                    </Typography.Title>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        onClick={() => {
                                                            navigate(`/cramSchool/admin/ConfirmTuitionFee`)
                                                        }}
                                                        type="link">
                                                        查看更多
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col
                                            span={24}
                                        >
                                            <div style={{
                                                height: '400px'
                                            }}
                                            >
                                                <LabelBarChart
                                                    XdataKey="name_serial"
                                                    barDatas={[
                                                        {
                                                            dataKey: "準時繳費",
                                                            fill: "#56b673"
                                                        },
                                                        {
                                                            dataKey: "逾期繳費",
                                                            fill: "#ffc400"
                                                        },
                                                        {
                                                            dataKey: "未繳費",
                                                            fill: "#ffc1c2"
                                                        },
                                                    ]}
                                                    barChartDatas={perClassPayment}
                                                />
                                            </div>
                                            {/* <DonutTable /> */}
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>


                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

const HistoryStatus = ({
    data = []
}) => {

    const config = {
        data,
        xField: 'student_name',
        xAxis: {
            position: 'bottom',
        },
        interactions: [
            {
                type: 'active-region',
            },
        ],
        yField: ['準時繳費', '逾期繳費'],
        tooltip: {
            shared: true,
            showMarkers: false,
        },
    };
    useEffect(() => {
        console.log({
            data
        })
    }, [data])
    return (<BidirectionalBar
        data={data}
        {...config}
    />)
}
export default ProtalMainPage

